// extracted by mini-css-extract-plugin
export default {"subtitulo":"ReaccionEditarScreen_subtitulo__RU+jD","boton":"ReaccionEditarScreen_boton__HIPKs","acordion":"ReaccionEditarScreen_acordion__a0nge"};